import * as React from 'react';
import { Link, LinkProps } from 'react-router-dom';

import { Lang } from '@common/typescript/objects/Lang';
import { useApplicationContext } from '@common/react/components/Core/Application/Application';
import { LanguageKeys } from '@common/react/objects/Language';

interface Props extends LinkProps {
	to: string;
	basePath?: string;
}

const LinkWithLang: React.FC<Props> = (props) => {
	const {
		getLang,
		getHostOptions,
	} = useApplicationContext();
	const language = getLang() ?? Lang.En;
	const path = getHostOptions().basePath;
	const {
		to, children, basePath = path, ...rest
	} = props;
	const link = to[0] === '/' ? to.substring(1) : to;

	return <Link to={`${basePath ?? ''}${language === Lang.En ? `/${link}` : `/${LanguageKeys[language]}/${link}`}`} {...rest}>{children}</Link>;
};

export default LinkWithLang;
